/* Remove every ShipInsure line when it is the only product in the cart. */
(function () {
  'use strict';

  var PRODUCT_ID = '8026849542362';
  var nativeFetch = window.fetch && window.fetch.bind(window);
  if (!nativeFetch) return;

  var running = null;
  var timer = null;
  var cartMutationVersion = 0;
  var completedVersion = -1;

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + path;
  }

  function isCartMutation(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    try {
      return /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(new URL(url, location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function hasOtherProduct(cart) {
    return !!(cart && cart.items && cart.items.some(function (item) {
      return Number(item.quantity) > 0 && String(item.product_id) !== PRODUCT_ID;
    }));
  }

  function getProtectionUpdates(cart) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (Number(item.quantity) > 0 && String(item.product_id) === PRODUCT_ID && item.key) {
        updates[String(item.key)] = 0;
      }
    });
    return updates;
  }

  async function readCart() {
    var response = await nativeFetch(cartUrl('cart.js'), {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function inspectCart() {
    var cart = await readCart();
    if (!cart.items || !cart.items.length || hasOtherProduct(cart)) {
      return { changed: false, cart: cart };
    }

    var updates = getProtectionUpdates(cart);
    if (!Object.keys(updates).length) return { changed: false, cart: cart };

    var payload = { updates: updates };
    var discountCodes = (cart.discount_codes || []).map(function (discount) {
      return discount && discount.code ? String(discount.code).trim() : '';
    }).filter(Boolean);
    if (discountCodes.length) payload.discount = discountCodes.join(',');

    // Keys address individual lines, including variants split by properties/discounts.
    var response = await nativeFetch(cartUrl('cart/update.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Unable to remove ShipInsure lines');
    return { changed: true, cart: await response.json() };
  }

  function validate() {
    if (running) return running;
    var successful = false;
    running = (async function () {
      var changed = false;
      var result;
      do {
        var version = cartMutationVersion;
        result = await inspectCart();
        changed = changed || result.changed;
        if (version === cartMutationVersion) {
          completedVersion = version;
          break;
        }
      } while (true);
      if (changed) document.dispatchEvent(new CustomEvent('shipinsure:cart-cleaned', { detail: result.cart }));
      successful = true;
      return { changed: changed, cart: result.cart };
    })().finally(function () {
      running = null;
      if (successful && completedVersion !== cartMutationVersion) queue();
    });
    return running;
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      validate().catch(function (error) { console.warn('[ShipInsure cart guard]', error); });
    }, 0);
  }

  function schedule() {
    cartMutationVersion += 1;
    queue();
  }

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : resource && resource.url;
    var method = options && options.method || resource && resource.method;
    var mutation = isCartMutation(url, method);
    return nativeFetch.apply(null, arguments).then(function (response) {
      if (mutation && response.ok) schedule();
      return response;
    });
  };

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._shipInsureCartMutation = isCartMutation(url, method);
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this._shipInsureCartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 300) schedule();
        }, { once: true });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('shipinsure:cart-cleaned', function () {
    if (window.WS && WS.ui && WS.ui.cartFn) {
      if (WS.site.page === 'cart' && WS.ui.cartFn.loadCartPage) WS.ui.cartFn.loadCartPage();
      else if (document.querySelector('#cart-drawer.is-active')) WS.ui.cartFn.request(false);
    }
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('#ws-cart-bag, #cart-icon-bubble')) schedule();
  }, true);
  document.addEventListener('DOMContentLoaded', schedule);

  window.shipInsureCartGuard = { validate: validate, hasOtherProduct: hasOtherProduct };
})();
